var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy } from '@angular/core';
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { HttpClient } from '@angular/common/http';
import { HttpClientAbstract } from 'src/app/shared/service/http-client-abstract';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as i0 from "@angular/core";
import * as i1 from "./http-header.service";
import * as i2 from "@angular/common/http";
import * as i3 from "ngx-toastr";
var MatchingFilterService = /** @class */ (function (_super) {
    __extends(MatchingFilterService, _super);
    function MatchingFilterService(header, http, toastrService) {
        var _this = _super.call(this, header, http) || this;
        _this.toastrService = toastrService;
        _this.subscriptions = new Subscription();
        return _this;
    }
    MatchingFilterService.prototype.ngOnDestroy = function () {
        this.subscriptions.unsubscribe();
    };
    MatchingFilterService.prototype.getMatchingFilters = function () {
        return _super.prototype.requestGet.call(this, 'api/v1/matching_filters');
    };
    MatchingFilterService.prototype.updateMatchingFilter = function (matchingFilter) {
        return _super.prototype.requestPost.call(this, 'api/v1/matching_filters/update', matchingFilter);
    };
    // 当座はOKの項目は設定変更できないように対応
    MatchingFilterService.prototype.switchOk = function (matchingFilter) {
        this.toastrService.info('この項目は変更できません。');
        // matchingFilter.ok = !matchingFilter.ok;
        // this.updateFilter(matchingFilter);
    };
    MatchingFilterService.prototype.switchNg = function (matchingFilter) {
        matchingFilter.ng = !matchingFilter.ng;
        this.updateFilter(matchingFilter);
    };
    MatchingFilterService.prototype.switchUnk = function (matchingFilter) {
        matchingFilter.unk = !matchingFilter.unk;
        this.updateFilter(matchingFilter);
    };
    MatchingFilterService.prototype.updateFilter = function (matchingFilter) {
        var _this = this;
        var updateSub = this.updateMatchingFilter(matchingFilter).subscribe(function (res) {
            matchingFilter = res.body.matching_filter;
            _this.toastrService.success('設定を変更しました。');
        }, function (err) {
            _this.toastrService.error('設定の変更に失敗しました。');
        });
        this.subscriptions.add(updateSub);
    };
    MatchingFilterService.ngInjectableDef = i0.defineInjectable({ factory: function MatchingFilterService_Factory() { return new MatchingFilterService(i0.inject(i1.HttpHeaderService), i0.inject(i2.HttpClient), i0.inject(i3.ToastrService)); }, token: MatchingFilterService, providedIn: "root" });
    return MatchingFilterService;
}(HttpClientAbstract));
export { MatchingFilterService };
